//action types
const ACCEPT_COOKIES = "ACCEPT_COOKIES";
export const COOKIE_ACCEPTED_STORAGE = "COOKIE_ACCEPTED_STORAGE";

//action creators
export const acceptCookies = () => ({
  type: ACCEPT_COOKIES,
});

// function

export const acceptCookieFunction = () => async (dispatch) => {
  localStorage.setItem(COOKIE_ACCEPTED_STORAGE, true);
  await dispatch(acceptCookies());
};

//Reducer
const cookieBannerInitialState = {
  isAccepted: false,
};

export default function cookieConsent(
  state = cookieBannerInitialState,
  action
) {
  switch (action.type) {
    case ACCEPT_COOKIES:
      return {
        ...state,
        isAccepted: true,
      };

    default:
      return state;
  }
}

//selectors
const verifyIfCookieIsAccepted = (state) => {
  const cookieAccepted =
    localStorage.getItem(COOKIE_ACCEPTED_STORAGE) === "true";
  return state.cookieConsent.isAccepted || cookieAccepted;
};

//mappers
export const mapStateToPropsCookieConsent = (state) => {
  const isCookiesAccepted = verifyIfCookieIsAccepted(state);

  return {
    isCookiesAccepted,
  };
};

export const mapDispatchToPropsCookieConsent = {
  acceptCookieFunction,
};
